import * as Types from '../../../generated/gqlTypes';

import { gql } from '@apollo/client';
export type CustomerDiscountFragment = { id: string, pk: number, value: any };

export const CustomerDiscountFragmentDoc = gql`
    fragment CustomerDiscountFragment on CustomerDiscountType {
  id
  pk
  value
}
    `;